import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const PauseIcon = React.forwardRef<SVGSVGElement, IconProps>(function PauseIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M6 19h4V5H6zm8-14v14h4V5z"/>
        </IconBase>
    );
});
